import { render, staticRenderFns } from "./ExpectedColumnar.vue?vue&type=template&id=6c20dbca&"
import script from "./ExpectedColumnar.vue?vue&type=script&lang=js&"
export * from "./ExpectedColumnar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports